import React, { useEffect, useState } from "react";
import { Card, CardContent, Hidden, Grid } from "@material-ui/core";
import { paymentService } from "./model/e_razor-pay-service";
import PaymentConfirmation from "./view/_payment-confirmation";
import { history } from "../../../../helpers";
import { useSelector } from "react-redux";
import { routePaths } from "../../../config/route-paths";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import EFooterSection from "../../../e_home-page/e_footer-section/e_footer-section";

const useStyles = makeStyles((theme) => ({
  cardHeight: {
    height: "96vh",
    background: theme?.palette?.eWhite?.base + " !important",
  },
  footerStyle: {
    bottom: 0,
    alignContent: "center",
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      position: "fixed",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "2%",
    },
  },
  '@global': {
    html: {
      height: "100%"
    },
    body: {
      height: "100%",
      backgroundColor: theme?.palette?.eFaint?.base
    }
  },
}));

export default function E_RazorPaymentConfirmation(props) {
  let [resp, setResp] = useState();
  let classes = useStyles();
  const [authPaymentConfirmation, setAuthPaymentConfirmation] = useState();
  let widgets = useSelector((state) => state?.parametersWidgets?.WidgetLookUp);
  let razorPayData = props.location?.state?.[0];
  let orderData = props.location?.state?.[1];
  let accountData = props.location?.state?.[2];
  const browserName = useSelector((store) => store?.browserDetect?.browserName);

  useEffect(() => {
    widgets &&
      widgets.map((item) => {
        if (item.widgetCode === "E_AUTH_PAYMENT") {
          let paymentConfirmation = item?.children?.find((item) => item?.widgetCode == "E_AUTH_PAYMENT.PAYMENT_CONFIRMATION")
          setAuthPaymentConfirmation(paymentConfirmation);
        }
      });
  }, [widgets]);

  useEffect(() => {
    if (razorPayData && orderData && accountData) {
      paymentService
        .postPaymentProcessing(orderData, razorPayData, accountData)
        .then((res) => {
          setResp(res?.data?.data?.postPaymentDetailsRazorPay);
        })
        .catch((err) => {
          if (err?.response?.status === 500 || err?.response?.status === 400) {
            history.push(routePaths.QUICK_PAY);
          }
        });
    }
  }, []);
  return (
    <>
      {
        authPaymentConfirmation?.widgetDefaultValue && (
          <>
                <Card 
                  className={classes.cardHeight}
                  style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
                >
                  <CardContent>
                    {resp && resp?.mainData ? (
                      <PaymentConfirmation response={resp} location="billpay" />
                    ) : (
                      <Skeleton />
                    )}
                  </CardContent>
                </Card>
                <div className={classes.footerStyle}>
                  <EFooterSection />
                  </div>
          </>
        )
      }
    </>
  );
}
